import { Outlet } from "react-router-dom";
import BaggageStats from "./BaggageStats";

export const adminBaggageStatsRoutes = [
  {
    path: "stats",
    element: Outlet,
    children: [
      {
        path: "",
        element: BaggageStats,
      },
    ],
  },
];
